import script from "./DialogAquatic.vue?vue&type=script&setup=true&lang=ts"
export * from "./DialogAquatic.vue?vue&type=script&setup=true&lang=ts"

import "./DialogAquatic.vue?vue&type=style&index=0&id=4d0317b7&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4d0317b7"]])

export default __exports__